import { render } from "./ListResourceTable.vue?vue&type=template&id=7222dfc6"
import script from "./ListResourceTable.vue?vue&type=script&lang=js"
export * from "./ListResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__